import { Component, ViewChild } from '@angular/core';
import { NavController, ViewController, Slides, App, Platform } from 'ionic-angular';
import { StorageService } from '../../providers/storage.service';
import { SigninPage } from '../signin/signin';
import { SysconfigService } from '../../services/sysconfig.service';
import * as $ from 'jquery';
import { AuthService } from '../../providers/auth.service';
import { AlertService } from '../../providers/alert.service';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { AppConfig } from '../../app/app.config';
@Component({
    selector: 'page-domains',
    templateUrl: 'domains.html',
    providers: [
        SysconfigService,
    ]
})
export class DomainsPage {
    apiUrlList: any;
    urlCount: number;
    httpCount: number = 0;
    constructor(
        private auth: AuthService,
        private sysService: SysconfigService,
        private storage: StorageService,
        public navCtrl: NavController,
        private config: AppConfig,
        public viewCtrl: ViewController,
        private alert: AlertService,
        private appCtrl: App,
        private iab: InAppBrowser,
        private platform: Platform,


    ) {
        this.apiUrlList = [];
        this.urlCount = 0;
        this.platform.ready().then(() => {
            this.platformsArr = this.platform.platforms();
        })
        // this.isAndroidWap = window.matchMedia('(display-mode: standalone)').matches;
        if (window.hasOwnProperty("AndroidInterface")) {
            // 属性存在
            this.isAndroidWap = true;
        } else {
            this.isAndroidWap = false;

            // 属性不存在
        }
    }

    autourl: any;
    isHasUrl: boolean = false;
    platformsArr;
    isAndroidWap: boolean;
    isAppScreen: boolean;
    hijackingUrl: string;
    downClick = false;
    isWap = AppConfig.isWap;
    ionViewDidLoad() {
        this.initScreen();
        this.getPlatformLineLists();
        this.apiUrlList = this.storage.read("APIS");
        console.log("storage APIS", this.apiUrlList);

    }

    // 获取所有域名
    getPlatformLineLists() {
        this.autourl = [];
        this.sysService.getPlatformLineList().then(res => {
            if (res != undefined && res.length > 0) {
                res.forEach(r => {
                    var unit = new urlModel;
                    if (r.LineType == 1) {
                        unit.urlVal = r.LineUrl;
                        this.autourl.push(unit);
                    } else if (r.LineType == 6) {
                        this.hijackingUrl = r.LineUrl;

                    }
                });
                this.getPing();
            }
        }).catch(err => {
            this.httpCount++;
            if (this.httpCount < 3) {
                this.getPlatformLineLists()
            } else {
                this.httpCount = 0;
                this.alert.showAlert('目前网络不稳定，请在更佳网络环境下打开软件');
            }
        })
    }

    //获取ping值
    getPing() {
        let self = this;
        if (this.autourl.length <= 0) {
            return;
        }
        this.autourl.forEach((r, i) => {
            this.ping({
                url: r.urlVal,
                i: i,
                interval: 60,
                disabled: true,
                afterPing: function (ping, opt) {
                    if (opt && !opt.disabled) {
                        ping = 9999;
                    }
                    ping = parseFloat(ping)/2;
                    r.pingVal = ping >= 3000 ? ">3s" : ping > 400 ? ">400ms" : parseInt(ping) + "ms";
                    r.colorVal = ping > 1000 ? "red" : ping > 400 ? "orange" : "green";
                    r.numberVal = ping;
                    r.disabled = opt.disabled;
                    self.autourl = self.autourl.sort((a, b) => {
                        return a.numberVal - b.numberVal;
                    });//升序
                    self.urlCount++;
                    if (self.urlCount === self.autourl.length) {
                        self.apiUrlList = self.autourl;
                        console.log("self.apiUrlList", self.apiUrlList);
                        self.storage.write('APIS', self.apiUrlList);
                        self.urlCount = 0;
                    }
                }
            });
        });



    }

    // 请求域名时的时间与返回的时间差
    ping(option) {
        var ping, requestTime, responseTime;
        var getUrl = function (url) {    //保证url带http://
            var strReg = "^((https|http)?://){1}";
            var re = new RegExp(strReg);
            return re.test(url) ? url : "http://" + url;
        }
        $.ajax({
            url: getUrl(option.url) + '/?' + (new Date()).getTime(),  //设置一个空的ajax请求
            type: 'GET',
            dataType: 'html',
            timeout: 3000,
            beforeSend: function () {
                if (option.beforePing) option.beforePing();
                requestTime = new Date().getTime();
            },
            success: function (xhr, status) {
                responseTime = new Date().getTime();
                ping = Math.abs(requestTime - responseTime);
                if (option.afterPing) {
                    option.afterPing(ping, option);
                }
            },
            error: function (err) {
                responseTime = new Date().getTime();
                ping = Math.abs(requestTime - responseTime);
                option.disabled = false;
                if (option.afterPing) {
                    option.afterPing(ping, option);
                }
            }
        })
    }


    // this.storage.writeString("playModeType", JSON.stringify(this.initall.currlottery.currentLotteryType));
    defaultApiUrl() {
        let url = this.autourl[0].urlVal;
        this.storage.writeString("apiUrl", url);
        this.storage.write("isGuide", true);//是否已经看过指引
        this.navCtrl.push(SigninPage);
    }

    settingFastLine(url) {
        if (this.platform.url().startsWith('http')) {
            this.iab.create(`${url}/login`, '_self');
        } else {
            this.storage.writeString('apiUrl', url);
            this.viewCtrl.dismiss();
        }
    }

    close() {
        this.viewCtrl.dismiss();
    }

    IsPC() {
        var userAgentInfo = navigator.userAgent;
        var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
        var flag = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
                flag = false;
                break;
            }
        }
        return flag;
    }
    //第三张图片左滑,跳转到首页
    swipeleft(e) {
        this.navCtrl.push(SigninPage);
    }
    // 检查网页链接是否已添加到主屏幕
    isAppInstalled(): boolean {
        return (window.navigator as any).standalone || false;
    }

    initScreen() {
        if ((window.navigator as any).standalone || false) {
            this.isAppScreen = true
        } else {
            this.isAppScreen = false;
        }
    }
    hijackingLink() {
        this.config.openUrl(this.hijackingUrl);
    }
}

export class urlModel {
    urlVal: string;
    pingVal: string;
    numberVal: number;
    colorVal: string;
    LineName: string;
}




// WEBPACK FOOTER //
// ./src/pages/domains/domains.ts